<template lang="html">
    <section class="product-package"  ref="package">
    	<div class="journeys-title">
    	购买须知
    	</div>
        <div class="info-item" v-if="packageData.packageDetails && (prdTmpId === 3)">
            <div class="info-item-title" v-if="packageData.packageDetails.length > 0">
                套餐说明
            </div>
            <div class="info-item-package" v-for="(item, index) in packageData.packageDetails"  :class="index == 0 ? 'first' : ''">
                <div class="package-name" v-if="item.pkgName">{{item.pkgName}}<span v-if="item.departCity">{{item.departCity}}</span></div>
                <div class="package-notice" v-if="item.text" v-html="item.text.replace(/([\\\n\n\\\r\r]+)/g,'</br>')"></div>
                <div class="package-apply package-notice" v-if="item.applyJourney">适用行程:{{item.applyJourney}}</div>
            </div>
        </div>
        <div class="info-item" v-if="detailData.destinationGroupPoiName">
            <div class="info-item-title">
                成团地点
            </div>
            <div class="info-item-cost">{{detailData.destinationGroupPoiName}}</div>
        </div>
        <div class="info-item" v-if="purchaseNotes.deliveryTime">
            <div class="info-item-title">
                发货时间
            </div>
            <div class="info-item-cost" v-html="purchaseNotes.deliveryTime.replace(/([\\\n\n\\\r\r]+)/g,'</br>')"></div>
        </div>
        <div class="info-item" v-if="backRule">
            <div class="info-item-title">
                使用规则
            </div>
            <div class="info-item-cost" v-html="backRule.replace(/([\\\n\n\\\r\r]+)/g,'</br>')"></div>
        </div>
        <div class="info-item" v-if="purchaseNotes.costContain">
            <div class="info-item-title">
                费用包含
            </div>
            <div class="info-item-cost" v-html="purchaseNotes.costContain.replace(/([\\\n\n\\\r\r]+)/g,'</br>')"></div>
        </div>
        <div class="info-item" v-if="purchaseNotes.costNoContain">
            <div class="info-item-title">
                费用不包含
            </div>
            <div class="info-item-cost" v-html="purchaseNotes.costNoContain.replace(/([\\\n\n\\\r\r]+)/g,'</br>')"></div>
        </div>
        <div class="info-item" v-if="purchaseNotes.reminder">
            <div class="info-item-title">
                温馨提示
            </div>
            <div class="info-item-cost" v-html="purchaseNotes.reminder.replace(/([\\\n\n\\\r\r]+)/g,'</br>')"></div>
        </div>
        <div class="info-item" v-if="reserveNotice && classBrandId != 115">
            <div class="info-item-title">
                预订须知
            </div>
            <div class="info-item-cost" v-html="reserveNotice.replace(/([\\\n\n\\\r\r]+)/g,'</br>')"></div>
        </div>
    </section>
</template>

<script>
export default {
  name: "Purchasenotes",
  props: {
    prdTmpId: {
      type: Number,
      default: function() {
        return 5;
      }
    },
    packageData: {
      type: Object,
      default: function() {
        return {};
      }
    },
    purchaseNotes: {
      type: Object,
      default: function() {
        return {};
      }
    },
    packageData: {
      type: Object,
      default: function() {
        return {};
      }
    },
    detailData: {
      type: Object,
      default: function() {
        return {};
      }
    },
    reserveNotice: {
      type: String,
      default: function() {
        return "";
      }
    },
    backRule: {
      type: String,
      default: function() {
        return "";
      }
    }
  },
  data() {
    return {};
  },
  computed: {
        classBrandId () {
            return this.$store.state.detail && this.$store.state.detail.baseInfo && this.$store.state.detail.baseInfo.classBrandId || 0;
        }
   },
  components: {},
  created: function() {},
  methods: {}
};
</script>

<style lang="scss">
@import "../../style/common.scss";

.product-package {
  .pic-item {
    img {
      display: block;
      width: 100%;
    }
  }
  .info-item {
    padding: 12px 12px 10px;
    background: #fff;
    &:nth-child(2) {
      margin-top: 0;
    }
    &-title {
      position: relative;
      height: 20px;
      font-size: 16px;
      color: $fontStrongColor;
      margin-bottom: 9px;
      &:before {
        content: "";
        position: absolute;
        left: -10px;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 4px;
        background: #2dbb55;
        border-radius: 100%;
      }
    }
    &-cont {
      font-weight: 300;
      font-size: 15px;
      color: #666666;
      line-height: 22px;
    }
    &-images {
      padding: 5px 0;
    }
  }
  .traffic-depart-name {
    padding: 0 8px 8px;
    overflow: hidden;
    .item {
      display: inline-block;
      height: 26px;
      width: 70px;
      border: 1px solid #cccccc;
      border-radius: 2px;
      text-align: center;
      margin-right: 14px;
      margin-top: 14px;
      overflow: hidden;
      float: left;
    }
    .show-all,
    .show-no {
      margin-right: 0;
    }
    .noType {
      margin-right: 0;
    }
    .active {
      border: 1px solid #2dbb55;
      color: #2dbb55;
    }
  }
  .traffic-info {
    .traffic-info-item {
      padding-top: 10px;
      overflow: hidden;
      position: relative;
      .resource-col {
        height: 56px;
      }
      .tsp {
        position: absolute;
        top: 10px;
        left: 10px;
        width: 16px;
        span {
          display: inline-block;
          text-align: center;
          line-height: 16px;
          width: 16px;
          height: 16px;
          border: 1px solid #ddd;
          box-sizing: border-box;
          font-size: 10px;
          color: #ddd;
          margin-top: 10px;
        }
      }
      .depart {
        position: absolute;
        top: 10px;
        left: 50px;
        margin: 0 6px;
        &-time {
          font-size: 16px;
          color: #051b28;
        }
        &-name {
          text-align: center;
          font-size: 12px;
          color: #999999;
        }
      }
      .middle {
        width: 140px;
        margin: 0 auto;
        text-align: center;
        .company-name {
          font-size: 12px;
          color: #666666;
          position: relative;
          &:before,
          &:after {
            content: "";
            position: absolute;
            top: 52%;
            background: rgba(221, 221, 221, 0.5);
            width: 30px;
            height: 1px;
          }
          &:before {
            left: 10px;
          }
          &:after {
            right: 10px;
          }
        }
        .company-num {
          font-size: 12px;
          color: #a5a5a5;
          line-height: 10px;
        }
      }
      .arrive {
        position: absolute;
        top: 10px;
        right: 50px;
        margin-left: 20px;
        &-time {
          font-size: 16px;
          color: #051b28;
        }
        &-name {
          text-align: center;
          font-size: 12px;
          color: #999999;
        }
      }
    }
  }
  .hotel-descr {
    color: #a5a5a5;
  }
  .hotel-list-item {
    color: #666;

    span {
      font-size: 14px;
      line-height: 25px;
      margin-right: 16px;
      color: #2a2a2a;
    }
  }
  .info-item {
    padding-bottom: 0;
    padding-right: 0;
  }
  .info-item-package,
  .info-item-cost {
    padding-bottom: 10px;
    padding-right: 12px;
    line-height: 22px;
    font-size: 15px;
    font-weight: 300;
    color: #666;

    .package-name {
      span {
        margin-left: 10px;
      }
    }
    .package-notice {
      margin-top: 6px;
    }
    .package-depart-city {
      margin-top: 5px;
      display: block;
      color: #2dbb55;
    }
  }
  .info-item-package {
    padding-top: 10px;
  }
  .first {
    padding-top: 0;
  }

  .info-item-package:nth-last-child(1) {
    border: none;
  }
  .info-item-cost {
    border: 0;
  }
  .notice,
  .cancel {
    span {
      font-size: 16px;
      color: #051b28;
      line-height: 16px;
    }
  }
  .notice {
    margin-top: 9px;
  }
  .line {
    height: 1px;
    margin-left: 12px;
    background-color: rgba(0, 0, 0, 0.05);
  }
}
</style>



// WEBPACK FOOTER //
// PurchaseNotes.vue